var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Execução de Rotas","titleIcon":"fas fa-clipboard-check"}},[_c('list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }